import { render, staticRenderFns } from "./mcs.vue?vue&type=template&id=1ad36428"
import script from "./mcs.vue?vue&type=script&lang=js"
export * from "./mcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports